import React from 'react';
import PropTypes from 'prop-types';
import millify from 'millify';

import './DealMetrics.css';

const DealMetrics = ({deal}) => (
  <dl styleName="metrics">
    <div>
      <dt>Allocation</dt>
      <dd>${millify(parseInt(deal.metrics.allocation / 100, 10))}</dd>
    </div>
    <div>
      <dt>Fee</dt>
      <dd>{deal.metrics.fees}</dd>
    </div>
    <div>
      <dt>IRR</dt>
      <dd>{parseInt(deal.metrics.targetIRR, 10) / 100}%</dd>
    </div>
    <div>
      <dt>Yield</dt>
      <dd>{parseInt(deal.metrics.targetCoC, 10) / 100}%</dd>
    </div>
  </dl>
);

DealMetrics.propTypes = {
  deal: PropTypes.object.isRequired,
};

export default DealMetrics;



// WEBPACK FOOTER //
// ./web/components/DealMetrics.js